<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on }">
        <v-icon :color="icon.color" v-bind="$attrs" v-on="on">
          {{ icon.name }}
        </v-icon>
      </template>
      <span>{{ icon.tooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'LinkStatus',
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    icons: {
      success: {
        color: 'success',
        name: 'link',
        tooltip: 'Affiliate URL contains [SOURCE] string',
      },
      failure: {
        color: 'warning',
        name: 'link',
        tooltip: "Affiliate URL doesn't contain [SOURCE] string",
      },
      missing: {
        color: 'grey lighten-2',
        name: 'link_off',
        tooltip: 'No affiliate URL set',
      },
    },
  }),
  computed: {
    containsSource() {
      if (!this.value) return false
      return this.value.includes('[SOURCE]')
    },
    icon() {
      if (!this.value) return this.icons.missing
      return this.containsSource ? this.icons.success : this.icons.failure
    },
  },
}
</script>
